import React, { useState } from 'react';
import '../../assets/styles/Franchise.css';
import axios from 'axios';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import config from "../../config";
function ReqfranchiseAssign({ closePopup,franchisedata, }) {
  const [licensesToAdd, setLicensesToAdd] = useState('');
  const [amount, setAmount] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!licensesToAdd || !amount || !password) {
      toast.error("All fields are required!");
      return;
    }
    setLoading(true);
    try {
      const response = await axios.post(`${config.apiBaseUrl}/admin/assignupdatelicense`, {
        id: franchisedata.id,
        licensesToAdd,
        amount,
        password,
      });
  
      if (response.status === 200) {
        toast.success("License Assign successfully!");
        setTimeout(() => {
          setLicensesToAdd("");
          setAmount("");
          setPassword("");
          closePopup();
        }, 2000);
      } else {
        toast.info(response.data.message || "Something went wrong");
        setLoading(false);
      }
    } catch (error) {
      console.error("Error submitting license upgrade:", error);
      if (error.response) {
        if (error.response.status === 401 && error.response.data.msg === "Invalid Admin Password") {
          toast.error("Invalid password. Please try again.");
        } else {
          toast.error(error.response.data.message || "Server error occurred.");
        }
      }
      setLoading(false); 
    }
  };
  
  return (
    <div className='Franchiseassign-cm'>  
    <ToastContainer/>
      <div className="franchiseassign-container mt-3">
      <h3 className="franchiseheadtxt">Franchise License Upgrade</h3>
        <div className='row'>
          <div className='col-12 mt-1'>
            <h4>Franchise details -</h4>
          </div>
          <div className='col-4 mt-2'>Name</div>
          <div className='col-8 mt-2'><strong>:</strong> {franchisedata.name} </div>
          <div className='col-4 mt-2'>Phone no</div>
          <div className='col-8 mt-2'><strong>:</strong> {franchisedata.phone_number}</div>
          <div className='col-4 mt-2'>Email</div>
          <div className='col-8 mt-2'><strong>:</strong> {franchisedata.email}</div>
          <div className='col-4 mt-2'>Company name</div>
          <div className='col-8 mt-2'><strong>:</strong> {franchisedata.company_name}</div>
          <div className='col-4 mt-2'>Location</div>
          <div className='col-8 mt-2'><strong>:</strong> {franchisedata.state}, {franchisedata.city}</div>
          <div className='col-4 mt-2'>Current Licenses</div>
          <div className='col-8 mt-2'><strong>:</strong> {franchisedata.available_license}</div>
          <div className='col-4 mt-2'>Last Purchase date</div> 
          <div className='col-8 mt-2'><strong>:</strong>{franchisedata.last_purchased_date ? new Date(franchisedata.last_purchased_date).toLocaleDateString("en-US"): null}</div>
        </div>
        <h5 className='mt-4'>Assign license -</h5>
        <div className='row'>
          <div className='col-4 mt-2'>Enter no of license</div>
          <div className='col-8 mt-2'> <strong>:</strong>  <input type="text"  value={licensesToAdd}
              onChange={(e) => setLicensesToAdd(e.target.value)} placeholder='Enter no of license' className='inputdivs' /></div>
          <div className='col-4 mt-2'>Enter amount</div>
          <div className='col-8 mt-2'> <strong>:</strong>  <input type="text" value={amount}
              onChange={(e) => setAmount(e.target.value)} placeholder='Enter amount' className='inputdivs' /> </div>
          <div className='col-4 mt-2'>Password</div>
          <div className='col-8 mt-2'> <strong>:</strong>   < input type="password"  value={password}
              onChange={(e) => setPassword(e.target.value)} placeholder='Enter password' className='inputdivs' /> </div> 
        </div>
        <div className="d-flex justify-content-end align-items-center mt-3 p-2">
          <button type="button" className=" Franchise-savebtn" onClick={handleSubmit} disabled={loading}>{loading ? "Processing..." : "Proceed"}</button>
        </div>
      </div>
      <div className='row mt-5'>
        <div className='d-flex justify-content-end mt-5'>
          <button type="button" className='btn btn-danger me-3' onClick={closePopup}>Close</button>
        </div>
      </div>
    </div>
  );
}

export default ReqfranchiseAssign;
